// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";

import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServicesList from "./pages/ServicesList";
import Services3 from "./pages/Services3";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import "react-medium-image-zoom/dist/styles.css";
import AdminProjectForm from "./pages/AdminProjectForm";
import AdminJobForm from "./pages/AdminJobForm";
import AdminApplicationsList from "./pages/AdminApplicationsList";
import LandingPage from "./pages/landingpage";

import MainPage from "./pages/Mainpage";
import Vendors from "./pages/Vendors";
import ScrollToTop from "./utils/ScrollToTop";
import Service2 from "./pages/Service2";
import Director from "./pages/Director";
import Career from "./pages/Career";


// inside <Routes>


import LandscapeCards from "./pages/Directors1";
import PortfolioCards from "./pages/PortfolioCards";
import Services5 from "./pages/Services5";
import { useNavigate } from "react-router-dom";

function App() {
    // Set body overflow:hidden on mobile view
    useEffect(() => {
      function handleResize() {
        if (window.innerWidth <= 640) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        document.body.style.overflow = '';
      };
    }, []);
  // Use a wrapper to access navigate inside Router
  function AppRoutes() {
    const navigate = useNavigate();
    return (
      <>
        <ScrollToTop />
        <MainLayout>
          <Routes>
            <Route path="/" element={<MainPage  />} />
            <Route path="/about" element={<About />} />
            <Route path="/director" element={<Director />} />
            <Route path="/services" element={<Services3/>} />
            <Route path="/serviceslist" element={<ServicesList onDiscover={() => navigate('/service2')} />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/services3" element={<Services3 />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/projects/new" element={<AdminProjectForm />} />
            <Route path="/service2" element={<Service2 />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/career" element={<Career />} />
            <Route path="/admin/jobs/new" element={<AdminJobForm />} />
            <Route path="/admin/jobs/applications" element={<AdminApplicationsList />} />
            <Route path="/directors1" element={<LandscapeCards />} />
            <Route path="/portfolio" element={<PortfolioCards />} />
            <Route path="/services5" element={<Services5 />} />
          </Routes>
        </MainLayout>
      </>
    );
  }
  return (
    <>
      {/* Global style for mobile overflow:hidden */}
      <style>{`
        @media (max-width: 640px) {
          body { overflow: hidden !important; }
        }
      `}</style>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
